import type { WireEnvelope } from './types';

export function parseEnvelope(data: unknown): WireEnvelope | null {
  let raw: unknown = data;
  if (typeof data === 'string') {
    try { raw = JSON.parse(data); } catch { return null; }
  }
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return null;
  const o = raw as Record<string, unknown>;
  if (typeof o.type !== 'string') return null;
  const payload = o.payload && typeof o.payload === 'object' && !Array.isArray(o.payload)
    ? (o.payload as Record<string, unknown>) : {};
  return { ...(o as object), type: o.type, payload } as WireEnvelope;
}
